<template>
  <div class="pc-policy-content">
    <div class="header">
      <DefaultHeader></DefaultHeader>
    </div>
    <div v-html="policyInfo.i18nContent" class="body"></div>
    <div class="footer">
      <CommonFooter class="common-footer" showFooterLink></CommonFooter>
    </div>
  </div>
</template>

<script>
import CommonFooter from '@/components/layout/footer/commonFooter.vue'
import DefaultHeader from '@/components/layout/header/defaultHeader.vue'

export default {
  components: {
    CommonFooter,
    DefaultHeader
  },
  props: {
    policyInfo: {
      type: Object,
      required: true
    }
  },
  data () {
    return {

    }
  },
  computed: {

  },
  created () {

  }
}

</script>

<style lang="scss" scoped>
.pc-policy-content {
  min-width: 1280px;
  min-height: 100%;

  .header {
    background: #f5f5f5;
    padding-bottom: 10px;
    position: relative;

    .background-wrapper {
      width: 100%;
      height: 330px;
      background: url($baseDomain + 'static/images_en/bgTop.jpg?t=1') repeat-x;
      position: absolute;
      top: 0;
      z-index: -1;
    }
  }

  .body {
    width: 980px;
    margin: auto;
    margin-top: 33px;
  }

  .footer {
    text-align: center;
    position: relative;

    .common-footer {
      line-height: 18px;
      color: #909399;
      text-align: center;
      flex-direction: column;
      align-items: center;
      width: initial;
      margin: 24px 0;
    }

    .background-wrapper {
      width: 100%;
      height: 320px;
      background: url($baseDomain + 'static/images_en/bgBottom.jpg?t=1') repeat-x;
      position: absolute;
      bottom: 0;
      z-index: -1;
    }
  }
}
</style>
